export default __webpack_public_path__ + "static/media/sara_hall.1932e7dc.png";